import { useState } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { FilePdf, FileXls, Info } from "@phosphor-icons/react";
import { toast } from "sonner";

export default function PXReports() {
  const { api } = useAuth();
  const [months, setMonths] = useState(9);
  const [busy, setBusy] = useState(null);

  const download = async (format) => {
    setBusy(format);
    try {
      const res = await api.post("/reports/px-competitor-brief", { format, months }, { responseType: "blob" });
      const name = (res.headers["content-disposition"] || "").match(/filename="?([^"]+)"?/)?.[1] || `PX_competitor_brief.${format === "excel" ? "xlsx" : "pdf"}`;
      const url = URL.createObjectURL(res.data); const a = document.createElement("a"); a.href = url; a.download = name; a.click(); URL.revokeObjectURL(url);
      toast.success(`${format === "excel" ? "Excel" : "PDF"} brief downloaded`);
    } catch (e) { toast.error(e.response?.data?.detail || "Export failed"); }
    setBusy(null);
  };

  return (
    <div data-testid="px-reports-page" className="space-y-6 max-w-3xl">
      <div>
        <h1 className="font-syne font-bold text-2xl text-white tracking-tight">Air Niugini — Competitor Brief</h1>
        <p className="text-text-secondary text-sm mt-1">AKL Competitor Fare Overview for circulation to Air Niugini. Routes HKG, MNL, SIN, TYO · Non-stop then One-stop blocks · Y and J side by side.</p>
      </div>

      <div className="bg-card-bg border border-[rgba(255,255,255,0.08)] rounded-xl p-5 space-y-4">
        <div>
          <p className="text-xs uppercase tracking-wider text-text-secondary mb-2">Travel window</p>
          <div className="flex bg-navy rounded-lg border border-[rgba(255,255,255,0.08)] p-0.5 w-fit">
            {[6, 9].map(m => <button key={m} data-testid={`px-brief-months-${m}`} onClick={() => setMonths(m)} className={`px-4 py-1.5 text-xs font-medium rounded-md ${months === m ? "bg-ci-blue text-white" : "text-text-secondary hover:text-white"}`}>{m} months</button>)}
          </div>
        </div>
        <div className="flex flex-wrap gap-3">
          <button onClick={() => download("pdf")} disabled={!!busy} data-testid="px-brief-export-pdf" className="inline-flex items-center gap-2 px-5 py-2.5 rounded-lg bg-ci-orange text-white font-semibold text-sm hover:opacity-90 disabled:opacity-50"><FilePdf size={18} weight="duotone" />{busy === "pdf" ? "Building…" : "Download PDF"}</button>
          <button onClick={() => download("excel")} disabled={!!busy} data-testid="px-brief-export-excel" className="inline-flex items-center gap-2 px-5 py-2.5 rounded-lg bg-ci-blue text-white font-semibold text-sm hover:opacity-90 disabled:opacity-50"><FileXls size={18} weight="duotone" />{busy === "excel" ? "Building…" : "Download Excel"}</button>
        </div>
      </div>

      <div className="bg-card-bg border border-[rgba(255,255,255,0.08)] rounded-xl p-5 text-sm text-text-secondary space-y-2" data-testid="px-brief-notes">
        <p className="text-white font-medium flex items-center gap-2"><Info size={16} className="text-ci-blue" />What the brief always includes</p>
        <ul className="list-disc pl-5 space-y-1 text-xs">
          <li>Cover with generated-at timestamp, travel window and the sample-date rule in plain English.</li>
          <li>PX row highlighted at the top of every block; pre-launch cells read "Not yet operating", unsourced cells read "—".</li>
          <li>A "Data sources and limitations" footer listing sources used, every unsourced cell, the PR interline caveat and the 17 Nov 2026 launch note.</li>
          <li>Data refreshes daily; circulate this brief on the slower cadence agreed with the client.</li>
        </ul>
      </div>
    </div>
  );
}
